import type { FC } from "react";
import { useEffect, useMemo } from "react";

import classNames from "classnames";

import { SpinningNumber } from "./components";

import styles from "./AnimatedNumber.module.scss";

type AnimatedNumberProps = {
  numberToAnimate: number;
  animationDuration?: number;
  containerClassName?: string;
  textClassName?: string;
  isAnimationDisabled?: boolean;
};

export const AnimatedNumber: FC<AnimatedNumberProps> = ({
  numberToAnimate,
  animationDuration = 1,
  isAnimationDisabled,
  textClassName,
  containerClassName,
}) => {
  const numbersArray = useMemo(() => numberToAnimate.toString().split("").map(Number), [numberToAnimate]);

  useEffect(() => {
    document.documentElement.style.setProperty("--animation-duration", `${animationDuration}s`);
  }, [animationDuration]);

  return (
    <div
      className={classNames(styles.container, containerClassName)}
      data-testid="animatedNumber"
      aria-label={numberToAnimate.toString()}
    >
      {isAnimationDisabled || numberToAnimate === 0 ? (
        <span className={classNames(styles.countNumber, textClassName)}>{numberToAnimate}</span>
      ) : (
        numbersArray.map((number, index) => (
          <SpinningNumber
            number={number}
            key={`spinningNumber-${index}`}
            textClassName={classNames(styles.countNumber, textClassName)}
          />
        ))
      )}
    </div>
  );
};
